export const COMPONENT_ID = 'field-description-popup-content';
